<template>
  <div class="filter mb-2">
    <CategoryTabs ref="categoryTabs" :categories="categories" :on-search="clickCategoryTab" />
    <div class="mb-2 d-flex justify-center">
      <v-card v-if="showFilter" class="filter-mob d-flex flex-column">
        <div class="flex-grow-1">
          <div v-if="!filter">
            <div class="d-flex justify-space align-center">
              <v-btn @click="$emit('handleShowFilter')" class="ma-2" icon large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <h3 class="ma-5">絞り込み</h3>
            <v-divider/>

            <v-list class="pt-0">
              <item
                :name="$t('item')"
                :value="selectedGenusNames()"
                menu="genus"
                @change="e=>filter=e"
              />
              <v-divider/>

              <item
                :name="$t('farm')"
                :value="selectedFarmNames()"
                menu="farm"
                @change="e=>filter=e"
              />
              <v-divider/>

            </v-list>
          </div>

          <div v-else-if="filter==='genus'">
            <Genus @click="clickHandler" @back="filter=null" @clearFilterBy="clearFilterBy"
              :genusIds="query.genusIds" :date="query.date" :category="query.category"/>
          </div>

          <div v-else-if="filter==='farm'">
            <Farm @click="clickHandler" @back="filter=null" @clearFilterBy="clearFilterBy"
              :farmIds="query.farmIds" :date="query.date" :category="query.category"/>
          </div>
        </div>

        <div v-if="!filter" class="d-flex justify-space-around mb-4">
          <v-btn color="#03A9F4" @click="clearFilter" outlined>{{ $t("clear") }}</v-btn>
          <v-btn class="blue" @click="search" style="width: 60%">{{ $t("search_for") }}</v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Item from "@/components/shop/products/FilterMobile/Item.vue";
import Genus from "@/components/shop/products/FilterMobile/Genus.vue";
import Farm from "@/components/shop/products/FilterMobile/Farm.vue";
import CategoryTabs from "@/components/shop/products/CategoryTabs.vue";

export default {
  components: {
    Item,
    Genus,
    Farm,
    CategoryTabs
  },
  props: {
    list: {
      type: Array,
      default: null
    },
    farms: {
      type: Array,
      default: null
    },
    categories: {
      type: Array,
      default: null
    },
    selectedDate: {
      type: String,
      default: null
    },
    showFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      query: {
        category: null,
        genusIds: "",
        farmIds: "",
        color: null,
        date: this.selectedDate,
        stem_size: null
      },
      filter: null,
      searchCriteria: null
    };
  },
  watch: {
    selectedDate: {
      handler() {
        if (this.$route.query.delivery_date) {
          this.query.date = this.$route.query.delivery_date;
        } else {
          this.query.date = this.selectedDate;
        }
      },
      deep: true
    },
  },
  methods: {
    initialize() {
      if (this.$route.query.category_id) {
        this.clickHandler({
          key: "category",
          value: this.$store.state.categories
            .find(category => category.id === Number(this.$route.query.category_id)) ?? null
        });
      }
      if (this.$route.query.flower_genus_id) {
        const genusIds = this.$route.query.flower_genus_id.split(",").map(_id => Number(_id));
        this.query.genusIds = [...new Set(genusIds)].join(",");
      }
      if (this.$route.query.farm_id) {
        const farmIds = this.$route.query.farm_id.split(",").map(_id => Number(_id));
        this.query.farmIds = [...new Set(farmIds)].join(",");
      }
      let stem_size = null;
      if (this.$route.query.stem_size) {
        stem_size = Number(this.$route.query.stem_size);
      }
      if (stem_size !== null) {
        this.clickHandler({
          key: "stem_size",
          value: stem_size
        });
      }
      this.setFilterCriteria();
    },
    setFilterCriteria() {
      const criterias = [];
      if (this.selectedGenusNames()) {
        criterias.push(this.selectedGenusNames());
      }
      if (this.selectedFarmNames()) {
        criterias.push(this.selectedFarmNames());
      }
      this.searchCriteria = criterias.join("; ");
      this.$emit("criteria-change", this.searchCriteria);
    },
    selectedGenusNames() {
      if (!this.query.genusIds) return "";
      return this.query.genusIds.toString().split(",").map(_id => this.$store.state.searchQuery.availableFlowerGenus.find(item => item.id === Number(_id)).name).join(", ");
    },
    selectedFarmNames() {
      if (!this.query.farmIds) return "";
      return this.query.farmIds.toString().split(",").map(_id => this.$store.state.searchQuery.availableFarms.find(item => item.id === Number(_id)).name).join(", ");
    },
    clickCategoryTab(e) {
      if (!e.value) {
        this.clearBy("category");
      } else {
        this.query.category = e;
        this.clickHandler(e);
        this.search();
      }
    },
    clickHandler(e) {
      if (["farmIds", "genusIds"].includes(e.key)) {
        this.query[e.key] = this.updateSelectedItems(this.query[e.key], e.value);
      } else {
        this.query[e.key] = this.query[e.key] === e.value ? null : e.value;
      }

      // if (e.key !== "color") {
      //   this.filter = null;
      // }
    },
    search() {
      this.$refs.categoryTabs.clearTab();
      this.setFilterCriteria();
      this.$emit("click", this.query);
    },
    clearFilter() {
      this.filter = null;
      // this.query.category = null;
      this.query.genusIds = "";
      this.query.farmIds = "";
      this.query.color = null;
      // this.query.date = null;
      this.query.stem_size = null;
      this.$emit("change", { key: "clear" });
    },
    clearFilterBy(e) {
      const initValue = (["farmIds", "genusIds"].includes(e.key)) ? "" : null;
      this.query[e.key] = initValue;
    },
    clearBy(key) {
      this.$refs.categoryTabs.clearTab();
      this.query[key] = null;
      this.search();
    },
    clearByStemSize() {
      this.query.stem_size = null;
      this.search();
    },
    updateSelectedItems(selectedItems, item) {
      let items = [];
      if (selectedItems.length > 0) items = selectedItems.toString()?.split(",");
      const index = items.findIndex(selectedItem => selectedItem.toString() === item.toString());
      // eslint-disable-next-line no-unused-expressions
      index === -1 ? items.push(item) : items.splice(index, 1);
      return items.join(",");
    }
  }
};
</script>

<style lang="scss">
.search-button-position {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 100;
}

.filter-mob {
  position: fixed;
  top: 0;
  left: 0;
  background: white;
  height: 100%; /* iOS 15.4未満対応 */
  height: 100dvh; /* iOS 15.4以降専用 */
  width: 100vw;
  overflow: auto;
  font-family: sans-serif;
  z-index: 5;

  &-font {
    font-weight: 500;
    font-size: 16px;

    color: #4A8FCF;
  }
}

.selected-item-icon {
  color: #4A8FCF !important;
}
</style>
